import { blue } from '@mui/material/colors';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Pagination } from '@mui/material'
import classes from './MyPagination.module.css'
interface IMyPaginationProps{
    page?: number,
    pages?: number,
    handlePageChange: (event: React.ChangeEvent<unknown>, value: number)=>void
}
const theme = createTheme({
    palette: {
      primary: {
        main: blue[600],
      },
    },
  });

const MyPagination: React.FC<IMyPaginationProps> = ({page, pages, handlePageChange})=>{
    return(
        <ThemeProvider theme={theme}>
        <div className='row justify-content-center' style={{boxSizing: 'border-box'}}>
            <div className={`col-md ${classes.paginationContainer}`}>
                <div className={classes.paginationDiv}>
                    <Pagination 
                        hidePrevButton 
                        hideNextButton 
                        page={page}
                        count={pages} 
                        variant="text" 
                        color="primary" 
                        onChange={handlePageChange}
                    />
                </div>
            </div>
        </div>
        </ThemeProvider>

    )
}

export default MyPagination